import { addLocationMutation } from '../../../lib/graphql/location';
import { setLoaderStart, setLoaderComplete } from '../../loader/loader';
import showToaster from '../../../helpers/toastrMessgaes/showToaster';
import history from '../../../history';

export const addLocation = (LocationName, coordinates, description) => {

  try {

    return async (dispatch, getState, { client }) => {

      dispatch(setLoaderStart('AddLocation'));

      const { data } = await client.mutate({
        mutation: addLocationMutation,
        variables: {
          LocationName,
          coordinates,
          description
        },

      });

      if (data?.addLocation?.status === 200) {
        showToaster({ messageId: 'addLoc', toasterType: 'success' });
        history.push('/siteadmin/location');
      } else if (data?.addLocation?.status !== 200) {
        showToaster({ messageId: 'errorMessage', requestContent: data?.addLocation?.errorMessage, toasterType: 'error' });
      }
      dispatch(setLoaderComplete('AddLocation'));
    }
  } catch (error) {
    showToaster({ messageId: 'errorMessage', requestContent: error, toasterType: 'error' });
    dispatch(setLoaderComplete('AddLocation'));
  }
};